<script>
	import { onMount } from 'svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';

	export let data;
	const { page } = data;

	/**
	 * @type {typeof import('svelte').SvelteComponent | undefined}
	 */
	let Component;

	onMount(async () => {
		if (page) {
			Component = await page.init();
		}
	});
</script>

{#if Component && page}
	<ComponentPageHead
		content={{
			...page.metadata,
			title: page.metadata.title ?? '',
			schemaOrgJson: page.metadata.schemaOrgJson ?? '',
			link: page.metadata.link ?? [],
			metaTag: page.metadata.metaTag ?? [],
		}}
	/>
	<svelte:component
		this={Component}
		pageData={data}
	/>
{/if}
